import React from 'react'

import { Stack } from '@mui/material'

import TimeInput from './TimeInput'
import { useTranslation } from 'react-i18next'
import { OpeningHoursEntry, OpeningHoursDay } from '@3m5/sm_publish-frontend-api'

type Props = {
  day: OpeningHoursDay
  index: number
  singleInput: OpeningHoursEntry
  onChange: (val: string, index: number, currentDay: OpeningHoursDay, point: string) => void
}

const OpeningHoursInput: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { singleInput, index, day, onChange } = props

  return (
    <Stack direction='row' spacing={2} mt={2}>
      <TimeInput
        initTime={singleInput.start}
        label={t('facebookSettingsCommon:from')}
        type='text'
        placeholder='00:00'
        size='small'
        onTimeChange={(val) => onChange(val, index, day, 'start')}
      />
      <TimeInput
        initTime={singleInput.end}
        label={t('facebookSettingsCommon:to')}
        type='text'
        placeholder='00:00'
        size='small'
        onTimeChange={(val) => onChange(val, index, day, 'end')}
      />
    </Stack>
  )
}

export default OpeningHoursInput
